module.exports = __webpack_public_path__ + "static/Sohne-Leicht-b2b487efcf34ffa21312009ac1400196.woff2";